<template>
    <div class="" >
        <div class="worker">
            <div class="inner">
                <div class="worker__name text-size-xxl text-color-white text-bold">
                    {{ activeMenuItem.name }}
                </div>

                <div class="worker__timer" v-if="worker.timer && worker.userId != user.id">
                    <div class="overtime" v-if="worker.timer.worked.time">
                        <div class="text-bold text-uppercase">
                            Работает с {{ worker.timer.worked.timeFormatStart }} (+{{worker.timer.worked.time}})
                        </div>
                    </div>
                    <div class="leave" v-else-if="worker.timer.leave.time">
                        <div class="text-bold text-uppercase">
                            Отсутствует с {{ worker.timer.leave.timeFormatStart }} (−{{ worker.timer.leave.time }})
                        </div>
                        <div class="text-italic">
                            «{{ worker.timer.leave.comment }}»
                        </div>
                    </div>
                </div>

                <div class="btns df" v-if="worker.timer && worker.userId == user.id">
                    <div class="btn-block mr16">
                        <tooltip
                                :direction="'top-center-direction'"
                                :is-btn-close="false"
                                v-if="!isWorkTime"
                                :add-style="{width: 188 + 'px'}">
                            <template v-slot:tooltipBtn>
                                <div class="btn--ghost"></div>
                            </template>
                            <template v-slot:tooltipContent>
                                <div class="text-size-s">
                                    Уйти в рабочее время можно только в рабочее время;)
                                </div>
                            </template>
                        </tooltip>
                        <button class="btn btn--mini" :class="{'btn--trans': !worker.timer.leave.time,'disabled':worker.timer.worked.time || !isWorkTime}" @click="openLeave">
                            <span>уйти в рабочее время</span>
                        </button>
                    </div>
                    <submit-btn tag="button"
                                class="btn--mini btn--trans loader-in mr16"
                                @click="openTakeDayOff"
                                :type="button">
                                взять отгул
                    </submit-btn>
                    <div class="btn-block">
                        <tooltip
                                :direction="'top-center-direction'"
                                :is-btn-close="false"
                                v-if="isWorkTime"
                                :add-style="{width: 204 + 'px'}">
                            <template v-slot:tooltipBtn>
                                <div class="btn--ghost"></div>
                            </template>
                            <template v-slot:tooltipContent>
                                <div class="text-size-s">
                                    Отработать сверхурочно можно только в нерабочее время;)
                                </div>
                            </template>
                        </tooltip>

                        <button class="btn btn--mini" :class="{'btn--trans': !worker.timer.worked.time,'disabled':worker.timer.leave.time || isWorkTime}" @click="openWorkOvertime">
                            <span v-if="!worker.timer.worked.time">отработать сверхурочно</span>
                            <span v-else>закончить сверхурочную работу</span>
                            <span  v-if="worker.timer.worked.time" class="time">− {{ worker.timer.worked.time }}</span>
                        </button>
                    </div>
                </div>
                <div class="worker__stats" v-if="worker.timer" :class="{'must': !(worker.days >= 0 && worker.time >= 0)}">
                    <span class="df">
                        <tooltip
                                :direction="'top-center-direction'"
                                :is-btn-close="false"
                                :add-style="{width: 328 + 'px'}">
                            <template v-slot:tooltipBtn>
                                <span class="i i-info4 i--white-trans"></span>
                            </template>
                            <template v-slot:tooltipContent>
                                <div class="text-size-s">
                                    Накопленные отгулы (более 20 отработанных дней в месяц) считаются в конце месяца. Запланированные отгулы вычетаются по достижению даты отгула. А всё остальное считается сразу.
                                </div>
                            </template>
                        </tooltip>
                        <span class="text-uppercase text-size-xs mr16" v-if="worker.days >= 0 && worker.time >= 0">Накоплено:</span>
                        <span class="text-uppercase text-size-xs mr16" v-else>Долг:</span>
                    </span>
                    <div class="item">
                        <div class="name">
                            дн.
                        </div>
                        <div class="count">
                            {{workerTime.days}}
                        </div>
                    </div>
                    <div class="item">
                        <div class="name">
                            час.
                        </div>
                        <div class="count">
                            {{ workerTime.hours }}
                        </div>
                    </div>
                    <div class="item">
                        <div class="name">
                            мин.
                        </div>
                        <div class="count">
                            {{ workerTime.minutes  }}
                        </div>
                    </div>

                </div>
            </div>

        </div>
        <div class="months" v-if="months.length > 0">
            <div class="days-off" v-if="plan.length > 0">
                <div class="text-size-s text-uppercase text-bold">
                    Запланировано отгулов: {{ plan.length }}
                </div>
                <div class="days-off__list">
                    <div class="days-off__list-item" v-for="planItem in plan">
                        {{ planItem.dateFuture }}
                        <div @click="cancelHoliday(planItem.id)" class="remove" v-if="worker.userId == user.id">
                          <svg>
                             <use xlink:href="@/assets/img/close.svg#close"/>
                          </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="month" v-for="(month, index) in months" :key="index" :class="{'current': index == 0, 'opened': month.isOpen}" >
                <div class="month__header" @click="toggleMonth(index)">
                    <div class="date">
                        <div class="month-name">
                            {{ month.name }}
                        </div>
                        <div class="year">
                            {{ month.year }}
                        </div>
                    </div>
                    <div class="month__header-item">
                        <div class="text-size-s text-color-grey">
                            рабочих дней по календарю:
                        </div>
                        <div class="val">
                            {{ month.workDays }}
                        </div>
                    </div>
                    <div class="month__header-item">
                        <div class="text-size-s text-color-grey">
                            Нужно отработать:
                        </div>
                        <div class="val">
                            {{ month.needWork }}
                        </div>
                    </div>
                    <div class="month__header-item">
                        <div class="text-size-s text-color-grey">
                            Отработано:
                        </div>
                        <div class="val" v-if="!month.isCurrent">
                            {{ month.worked }}
                        </div>
                        <div class="quest text-bold text-color-grey" v-else>
                            ?
                        </div>
                    </div>
                    <div class="month__header-item">
                        <div class="text-size-s text-color-grey">
                            Накоплено:
                        </div>
                        <div class="val" v-if="!month.isCurrent">
                            {{ month.save }}
                        </div>
                        <div class="quest text-bold text-color-grey" v-else>
                            ?
                        </div>
                    </div>
                </div>
                <div class="month__calendar">
                    <div class="month__calendar-header">
                        <div class="weekday">
                            пн
                        </div>
                        <div class="weekday">
                            вт
                        </div>
                        <div class="weekday">
                            ср
                        </div>
                        <div class="weekday">
                            чт
                        </div>
                        <div class="weekday">
                            пт
                        </div>
                        <div class="weekday">
                            сб
                        </div>
                        <div class="weekday">
                            вс
                        </div>
                    </div>
                    <div class="month__calendar-days">
                        <div class="day" v-for="i in month.emptyBefore"></div>
                        <div class="day" v-for="day in month.days" :class="{'weekend': day.isWeekend, 'current': day.isToday}">
                            <div class="num">{{ day.number }}</div>
                            <div  v-for="(event, indexEvent) in day.events" class="event-block">
                                <tooltip
                                        :direction="'top-center-direction'"
                                        :is-btn-close="false"
                                        :key="indexEvent"
                                        v-if="(event.type == 'leave' || event.type == 'worked') && event.start && event.end || !(event.type == 'leave' || event.type == 'worked')"
                                        :add-class-wrap="'event-wrap'"
                                        :add-style="{width: 200 + 'px'}"
                                       >
                                    <template v-slot:tooltipBtn>
                                        <span v-if="event.type == 'holiday'" class="event day-off">− 1 день</span>
                                        <span v-if="event.type == 'leave'" class="event time-remove">− {{ event.time }}</span>
                                        <span v-if="event.type == 'worked'" class="event time-add">+ {{ event.time }}</span>
                                        <span v-if="event.type === 'converted_plus' || event.type === 'official_holidays' || event.type === 'vacation'" class="event time-add">+ 1 день</span>
                                        <span v-if="event.type == 'converted_minus'" class="event day-off">- 1 день</span>
                                    </template>
                                    <template v-slot:tooltipContent>
                                        <div class="text-color-grey text-size-s" v-if="event.start && event.end">{{ event.start }} – {{ event.end }}</div>
                                        <div class="text-color-grey text-size-s" v-else>{{ event.start }}</div>
                                        <div class="text-bold text-size-s">
                                            {{ event.comment}}
                                        </div>
                                        <span class="btn btn--blue mt8" @click="cancelHoliday(event.id)" v-if="worker.userId == user.id && !day.isPast && event.type == 'holiday'">Отменить отгул</span>
                                    </template>
                                </tooltip>
                            </div>

                        </div>
                        <div class="day" v-for="i in month.emptyAfter"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="months --ghost" v-else>
            <div class="month" v-for="i in 3" :class="{'current': i == 1}">
                <div class="month__header">
                    <div class="date ghost-elem">
                        <div class="month-name">
                        </div>
                    </div>
                    <div class="month__header-item">
                        <div class="text-size-s text-color-grey ghost-elem">
                        </div>
                        <div class="val ghost-elem">
                        </div>
                    </div>
                    <div class="month__header-item">
                        <div class="text-size-s text-color-grey ghost-elem">
                        </div>
                        <div class="val ghost-elem">
                        </div>
                    </div>
                    <div class="month__header-item">
                        <div class="text-size-s text-color-grey ghost-elem">
                        </div>
                        <div class="val ghost-elem">
                        </div>
                    </div>
                    <div class="month__header-item">
                        <div class="text-size-s text-color-grey ghost-elem">
                        </div>
                        <div class="val ghost-elem">
                        </div>
                    </div>
                </div>
                <div class="month__calendar">
                    <div class="month__calendar-header">
                        <div class="weekday">
                            пн
                        </div>
                        <div class="weekday">
                            вт
                        </div>
                        <div class="weekday">
                            ср
                        </div>
                        <div class="weekday">
                            чт
                        </div>
                        <div class="weekday">
                            пт
                        </div>
                        <div class="weekday">
                            сб
                        </div>
                        <div class="weekday">
                            вс
                        </div>
                    </div>
                    <div class="month__calendar-days">
                        <div class="day" v-for="i in 35"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <popup :show="popups.workTime.show"
           :width="536"
           :name="popups.workTime.name">
        <work-time @set="setIsWorkTime"/>
    </popup>
</template>

<script>
// @ is an alias to /src

import {mapState} from "vuex";
import Tooltip from '@/components/Tooltip.vue';
import SubmitBtn from '@/components/forms/SubmitBtn.vue';
import Popup from '@/components/modal/Popup.vue';

import WorkTime from '@/components/modal/WorkTime.vue';

export default {
    name: 'Home',
    components: {
        Tooltip,
        SubmitBtn,
        Popup,
        WorkTime,
    },
    data: function(){
        return {
            currentDate: new Date(),
            openMonth: false,
            isWorkTime: false,
            button: 'normal',
        }
    },
    created() {
        /*this.$watch(
            () => this.$route.params,
            () => {
                this.fetchData()
            },
            // fetch the data when the view is created and the data is
            // already being observed
            { immediate: true }
        )*/
    },
    mounted() {
        this.$store.dispatch('workers/getItem',{id:this.activeMenuItem.id}).then(()=>{
            this.setIsWorkTime();
            setInterval(this.setIsWorkTime,1000)
        });
    },
    computed: {
        ...mapState({
            menuList: state => state.menus.itemsTop,
            user: state => state.auth.user,
            popups: state => state.popups.items,
            worker: state => state.workers.item,
            months: state => state.workers.months,
            plan: state => state.workers.plan,
        }),
        workerTime(){
            let time = {
                hours: '00',
                minutes: '00',
                days: '00',
            }
            let workerTime = this.worker.time;
            if(workerTime < 0){
                workerTime = -workerTime;
            }
            if(workerTime > 0 && workerTime < 60){
                time.hours = '00';
                time.minutes = '01';
            } else if(workerTime > 0){
                time.hours = Math.floor(workerTime / 60 / 60);
                time.minutes = Math.floor(workerTime / 60) - (time.hours * 60);
                if(time.hours < 10){
                    time.hours = '0'+time.hours;
                }
                if(time.minutes < 10){
                    time.minutes = '0'+time.minutes;
                }
            }
            if(this.worker.days < 0){
                time.days = this.worker.days * -1;
            } else {
                time.days = this.worker.days;
            }
            if(time.days < 10){
                time.days = '0'+time.days;
            }

            return time;
        },
        activeMenuItem() {
            let item = {};
            let id = '';
            if (this.$route.params.id) {
                id = this.$route.params.id;
            }

            if (!id && Object.values(this.menuList)[0]) {
                for(let m in this.menuList){
                    if(this.user.id == this.menuList[m].userId){
                        item = this.menuList[m];
                    }
                }
            } else {
                for(let m in this.menuList){
                    if(id == this.menuList[m].id){
                        item = this.menuList[m];
                    }
                }
            }

            return item;
        }
    },
    methods: {
        toggleMonth(index){
            this.$store.commit('workers/toggleMonthOpened', index)
        },
        openTakeDayOff(){
            this.$store.dispatch('popups/open', {name: this.popups.takeDayOff.name});
        },
        openLeave(){
            if(this.isWorkTime) {
                this.$store.dispatch('popups/open', {name: this.popups.leave.name});
            }

        },
        openWorkOvertime(){
            if(!this.isWorkTime) {
                this.$store.commit('auth/setWorkOvertimeNoComment',{})
                this.$store.dispatch('workers/workOvertime',{timeType:'start'})
            }
        },
        fetchData() {
            this.$store.commit('workers/setItem', {item: {}, months: []});
            this.$store.dispatch('workers/getItem', {id:this.activeMenuItem.id});
        },
        cancelHoliday(id){
            this.$store.dispatch('workers/cancelHoliday', id);
            document.getElementById('app').click()
        },
        setIsWorkTime(){
            let time = +new Date().toLocaleString("ru-Ru", {timeZone: "Europe/Moscow",hour: 'numeric'});
            let numDay = +new Date().toLocaleString("ru-Ru", {timeZone: "Europe/Moscow",day: 'numeric'});
            let day = new Date().toLocaleString('en-US', {timeZone: "Europe/Moscow",weekday: 'narrow'}).toLowerCase();
            let startHour = +this.user.workTimeStart.split(':')[0];
            let endHour = +this.user.workTimeEnd.split(':')[0];
            let isWorkDay = true;
            if(this.months[0]) {
                for(let e in this.months[0].days[numDay-1].events) {
                    if(this.months[0].days[numDay-1].events[e].type == 'holiday'){
                        isWorkDay = false
                    }
                }
                this.isWorkTime = time >= startHour && time < endHour && day !== 's' && isWorkDay;
                if(this.worker.userId == this.user.id) {
                    if(this.isWorkTime && this.worker.timer.worked.time){
                        this.$store.commit('workers/finishTimer');
                        this.$store.dispatch('workers/workOvertime',{timeType:'end', text:'', workOvertimeNoComment: false})
                        this.$store.dispatch('popups/open', {name: this.popups.workOvertime.name});
                    }
                    if(!this.isWorkTime && this.worker.timer.leave.time){
                        this.$store.dispatch('workers/leave',{timeType:'end'});
                    }
                }
            }


        },
    },
    watch: {
        '$route': 'fetchData'
    },
}
</script>
